import { useQuery } from "react-query";
import { getCurrentRates } from "helpers/rates";

export const useRates = () => {
  const { data, isLoading, error } = useQuery("rates", getCurrentRates);

  return { rates: data, isLoading, error };
};
